import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';
import { badgeEstado, textoEstado, nombreTipo, textoReferencia, textoAdjunto } from '../utils/emailLog';

var config = process.env;

// Detalle de un envío: pantalla propia y no modal. El cuerpo de un mail necesita espacio y el
// modal de Bootstrap se lleva mal con navegar desde adentro.
//
// ⚠️ NO sirve como link para compartir, y no es culpa de esta pantalla: `public/index.html`
// referencia el CSS con rutas RELATIVAS (`./css/all.css`), así que cualquier ruta de dos
// niveles cargada en frío las resuelve contra `/emailLog/` y la página sale sin estilos. Le
// pasa igual a `/editEmailTemplate/:key`, que ya existía. Entrando desde el listado (navegación
// del router, sin recarga) anda bien, que es el camino real.
class EmailLogDetailPage extends Component {

    constructor() {
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole,
            item: null,
            loaded: false,
            error: '',
        };
    }

    async componentDidMount() {
        const role = await validateSession(true);
        this.setState({ checked: true, role });
        this.fetchDetail();
    }

    fetchDetail = () => {
        const id = this.props.match.params.id;
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}emailLog/${id}`, {
            method: 'GET',
            headers: { 'access-token': localStorage.getItem('token'), 'Content-Type': 'application/json' },
        })
            .then((r) => r.json())
            .then((data) => {
                if (data.error > 0) {
                    if (data.error == 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                        return;
                    }
                    this.setState({ loaded: true, error: data.message });
                    return;
                }
                this.setState({ loaded: true, item: data.data });
            })
            .catch(() => this.setState({ loaded: true, error: 'No se pudo cargar el envío' }));
    }

    dato = (etiqueta, valor) => (
        <div className="col-md-6 mb-2">
            <div className="text-muted" style={{ fontSize: 12 }}>{etiqueta}</div>
            <div style={{ wordBreak: 'break-word' }}>{valor == null || valor === '' ? '—' : valor}</div>
        </div>
    )

    renderCuerpo = () => {
        const item = this.state.item;
        if (!item.bodyStored) {
            return (
                <div className="alert alert-secondary mb-0">
                    De este envío no se guardó el cuerpo: es anterior al 4/9/2026, cuando se empezó a
                    guardar. Lo que sí está registrado es que salió, a quién y con qué asunto.
                </div>
            );
        }
        return (
            <iframe
                title="Cuerpo del mail"
                srcDoc={item.bodyHtml || ''}
                // El HTML lo escribió una plantilla editable: se dibuja AISLADO, sin scripts y sin
                // acceso al origen del backoffice. Sin sandbox, editar una plantilla sería una vía
                // para ejecutar código en la sesión del admin que abre este detalle.
                sandbox=""
                style={{ width: '100%', height: '70vh', border: '1px solid #e1e5eb', borderRadius: 4, background: '#fff' }}
            />
        );
    }

    renderContenido = () => {
        if (!this.state.loaded) {
            return (
                <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%', padding: '2rem' }}>
                    <div className="loader"></div>
                </div>
            );
        }
        if (this.state.error || !this.state.item) {
            return <div className="alert alert-danger">{this.state.error || 'El envío no existe'}</div>;
        }

        const item = this.state.item;
        return (
            <div className="row">
                <div className="col-lg-5 mb-3">
                    <div className="card card-small h-100">
                        <div className="card-header border-bottom d-flex justify-content-between align-items-center">
                            <h6 className="m-0">Envío</h6>
                            <span className={`badge ${badgeEstado(item.status)}`}>{textoEstado(item.status)}</span>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                {this.dato('Fecha y hora', String(item.date || '').replace('T', ' '))}
                                {this.dato('Tipo', nombreTipo(item.templateKey))}
                                {this.dato('Para', item.recipient)}
                                {this.dato('De', item.sender)}
                                {this.dato('Responder a', item.replyTo)}
                                {this.dato('Asunto', item.subject)}
                                {this.dato('Referencia', textoReferencia(item.referenceType, item.referenceId))}
                                {this.dato('Copia', item.copyOf === 'internal' ? 'Interna (info@)' : item.copyOf === 'customer' ? 'Al cliente' : '—')}
                                {this.dato('Transporte', item.backend)}
                                {/* Con este id se busca el mail en la consola de SES. */}
                                {this.dato('ID en el proveedor', item.providerMessageId)}
                            </div>

                            {item.attachments && item.attachments.length > 0 && (
                                <div className="mt-2">
                                    <div className="text-muted" style={{ fontSize: 12 }}>Adjuntos</div>
                                    <ul className="mb-0 pl-3">
                                        {item.attachments.map((a, i) => (<li key={i}>{textoAdjunto(a)}</li>))}
                                    </ul>
                                    {/* Se guardan los metadatos, no el archivo: el PDF se vuelve a
                                        pedir desde la factura y guardarlo duplicaría la tabla. */}
                                    <div className="text-muted" style={{ fontSize: 11 }}>
                                        Se registra el archivo que salió, no el archivo en sí.
                                    </div>
                                </div>
                            )}

                            {item.status !== 'SENT' && (
                                <div className={`alert ${item.status === 'FAILED' ? 'alert-danger' : 'alert-secondary'} mt-3 mb-0`}>
                                    <strong>{item.errorCode || 'Sin código'}</strong>
                                    <div style={{ fontSize: 13 }}>{item.errorMessage || 'Sin detalle'}</div>
                                </div>
                            )}

                            {item.status === 'SENT' && (
                                // Lo más importante de esta pantalla: que no se lea como acuse de
                                // recibo. La tabla registra lo que se entregó a SES; un rebote llega
                                // después y hoy no se guarda en ningún lado.
                                <div className="alert alert-light mt-3 mb-0" style={{ fontSize: 12 }}>
                                    <strong>Enviado</strong> significa que SES lo aceptó. Si el mail rebotó
                                    después, ese aviso llega a info@enigmagames.uy y todavía no se registra acá.
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="col-lg-7 mb-3">
                    <div className="card card-small h-100">
                        <div className="card-header border-bottom"><h6 className="m-0">El mail que salió</h6></div>
                        <div className="card-body">{this.renderCuerpo()}</div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.state.checked) return (<div></div>);
        return (
            <div class="container-fluid">
                <div class="row">
                    <SidebarComponent itemSelected={47} role={this.state.role} />
                    <main class="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Comunicaciones" subtitle="Detalle del envío" />
                            <button type="button" className="btn btn-sm btn-outline-secondary mb-3"
                                onClick={() => navigateTo('/emailLog')}>← Volver a los envíos</button>
                            {this.renderContenido()}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default EmailLogDetailPage;
